import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import OtpLogin from "@/components/OtpLogin";
import { useAuth } from "@/lib/auth";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { setUser, setTenant } = useAuth();

  return (
    <div className="min-h-screen lg:grid lg:grid-cols-2 bg-slate-50">
      <div className="relative hidden lg:flex flex-col justify-between p-12 grid-bg bg-white">
        <div>
          <div className="flex items-center gap-2 mb-12">
            <div className="w-8 h-8 rounded bg-slate-900 grid place-items-center text-white font-bold">R</div>
            <span className="font-display text-xl font-bold">Rental.SaaS</span>
          </div>
          <h1 className="font-display text-4xl font-extrabold tracking-tight max-w-md text-slate-900">
            App Owner control panel
          </h1>
          <p className="mt-4 text-slate-600 max-w-md">
            Manage tenants, subscription plans, revenue, and platform-level analytics.
          </p>
        </div>
        <div className="flex gap-3 text-xs text-slate-500">
          <ShieldCheck className="h-4 w-4 text-emerald-600" /> Secure phone-OTP only access
        </div>
      </div>

      {/* Mobile header */}
      <div className="lg:hidden bg-white border-b border-slate-200 px-5 py-4 flex items-center gap-2" data-testid="admin-login-mobile-header">
        <div className="w-8 h-8 rounded bg-slate-900 grid place-items-center text-white font-bold text-sm">R</div>
        <div>
          <div className="font-display text-base font-bold leading-none">Rental.SaaS</div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5">App Owner Login</div>
        </div>
      </div>

      <div className="flex items-start sm:items-center justify-center px-4 sm:px-6 py-6 sm:py-10 min-h-[calc(100vh-64px)] lg:min-h-screen">
        <OtpLogin
          scope="admin"
          title="Sign in as App Owner"
          subtitle={"Test phone: 9999900001 • OTP: 123456"}
          testIdPrefix="admin-login"
          onSuccess={(data) => { setUser(data.user); setTenant(null); nav("/admin"); }}
        />
      </div>
    </div>
  );
}
